import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { formatAmount } from "../../common/StyledComponents/StyledFields";
import { useEffect, useRef, useState } from "react";
import Pagination from "../../common/pagination/pagination";
import { apiRequest } from "../../../infrastructure/backendService";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const PoojaReportsTableData = (props: any) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setTotalRecords(props.totalDrillDownData.totalElements);
    setPageSize(props.totalDrillDownData.pagesize)
  }, [])

  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }
  
  // useEffect(() => {
  //   if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
  //     searchDataApi();
  //   }
  // }, [pageNumber, prevPageNumber]);


  
  return (
    <>
      {props.ReportData.length === 0 && (
        <Typography
          sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}
        >
          <b>No Records found</b>
        </Typography>
      )}
      <StyledTableContainer sx={{ width: "100%" }}>
        <StyledTable aria-label="customized table">
          <TableHead>
            <TableRow>
              {Object.values(props.tableHeaders).map((header: any) => (
                <StyledTableCell align="center" key={header}>
                  <div
                    style={{ textTransform: "capitalize" }}
                    dangerouslySetInnerHTML={{ __html: header }}
                  />
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.ReportData.map((item: any, index: any) => (
              <StyledTableRow key={index}>
                {Object.keys(props.tableHeaders).map((column) => (
                  <StyledTableCell key={column}>
                    <div dangerouslySetInnerHTML={{ __html: item[column] }} />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
            {props.ReportName === "Pooja Booking summary by sign-in name" && (
              <StyledTableRow style={{ backgroundColor: "#F2BE22" }}>
                <StyledTableCell>
                  <div
                    style={{
                      textTransform: "capitalize",
                      alignItems: "flex-start",
                      verticalAlign: "top",
                    }}
                    dangerouslySetInnerHTML={{ __html: "Total" }}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      textTransform: "capitalize",
                      alignItems: "flex-end",
                      verticalAlign: "top",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: props.totalPooajs,
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      textTransform: "capitalize",
                      alignItems: "flex-end",
                      verticalAlign: "top",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: props.totalTime,
                    }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {props.ReportName === "Pooja Booking Report" &&
        props.ReportData.length !== 0 && (
          <>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                marginTop: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Amount" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(
                    props.totalAmounts_PoojaBooking.grandTotal
                  ),
                }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Refund" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(
                    props.totalAmounts_PoojaBooking.refundamount
                  ),
                }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Amount" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(
                    props.totalAmounts_PoojaBooking.remaining_after_refund
                  ),
                }}
              />
            </div>
            {props.paginationInfo.totalRecords > 10 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              >
                <Pagination
                  items={props.paginationInfo.totalRecords}
                  itemsPerPage={10}
                  setPageNumber={props.paginationInfo.setPageNumber}
                  pageNumber={props.paginationInfo.pageNumber}
                />
              </div>
            ) : (
              ""
            )}
          </>
        )}
    </>
  );
};

export default PoojaReportsTableData;
